module.exports = __webpack_public_path__ + "static/media/btResult2.da1e86aa.png";